import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ButtonGroup, Dropdown } from 'react-bootstrap';

/**
 * The filter dropdowns, driven entirely by `menus`.
 *
 * It used to end with a hardcoded `Phantom Tokens` button that had no `onClick`
 * and no state behind it — three pages rendered a control that did nothing when
 * pressed. Removed 2026-11-02: *"phantom Tokens e gol, practic e nefolosit aici.
 * Vreau sa il inlocuim cu lista asta de masini, pe acelasi stil."*
 *
 * Project Token State puts its machine filter there instead; the other two pages
 * (Project Analytics, Orders Monitor) simply lose a dead button.
 *
 * A menu may carry `disabled` and `title` — a filter that cannot apply yet is
 * better shown greyed with the reason than hidden, or the group's shape changes
 * under the cursor as views are switched.
 */
const FilterButtonGroup = ({ menus }) => {
  return (
    <ButtonGroup className="position-static">
      {menus.map(menu => (
        <Dropdown key={menu.label} as={ButtonGroup} className="position-static">
          <Dropdown.Toggle
            variant="phoenix-secondary"
            className="px-7 flex-shrink-0 dropdown-caret-none"
            disabled={!!menu.disabled}
            title={menu.title || undefined}
          >
            {menu.label}
            <FontAwesomeIcon
              icon={faAngleDown}
              className="ms-2"
              transform="down-2"
            />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {menu.items.map((item, subIndex) => (
              <Dropdown.Item
                key={subIndex}
                onClick={item.onClick}
                disabled={!!item.disabled}
                title={item.title || undefined}
              >
                {item.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      ))}
    </ButtonGroup>
  );
};

export default FilterButtonGroup;
